import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useApiMutation } from "../../../Hooks/useApiMutation";
import instance from "../../../Interceptor/api_instance";
import { Spinner } from "../../../Components/LoadingAnimations/LoadingAnimations";
import { useNavigate } from "react-router-dom";
import SupplierSearch from "../../../Components/Inputs/SupplierSearch";
import LocationSearch from "../../../Components/Inputs/LocationSearch";
import { Button } from "../../../Components/ui/button";

const CreateReceipt = ({ close }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    supplier: null,
    location: null,
    reference_id: null,
    expected_date: null,
    received_date: null,
    currency: "USD",
    notes: "",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });

  const navigate = useNavigate();
  const { mutate, data, isLoading, error } = useApiMutation(async (e) => {
    e.preventDefault();
    const response = await instance.post("/safety/receipts/", {
      ...formData,
      supplier: formData.supplier.value,
      location: formData.location ? formData.location.value : null,
    });
    if (response.status === 201) navigate(`/receipts/${response.data.id}`);
  });

  return (
    <div className="page-mask page-mask-animation">
      <div className="white-cont">
        <form onSubmit={mutate}>
          <h2>Create Receipt</h2>
          <div className="form-block">
            <label className="required">
              {t("yard-tables.table-columns.location")}
            </label>
            <div className="input-cont">
              <LocationSearch
                onSelect={(option) =>
                  setFormData((prev) => ({
                    ...prev,
                    location: option,
                  }))
                }
                selectedOption={formData.location}
              />
            </div>
          </div>
          <div className="form-block">
            <label className="required">{t("searchFilters.supplier")}</label>
            <div className="input-cont">
              <SupplierSearch
                onSelect={(option) =>
                  setFormData((prev) => ({
                    ...prev,
                    supplier: option,
                  }))
                }
                selectedOption={formData.supplier}
              />
            </div>
          </div>
          <div className="form-block">
            <label>{t("yard-tables.table-columns.referenceId")}</label>
            <div className="input-cont">
              <input
                type="text"
                value={formData.reference_id}
                className="text-input"
                onChange={(e) =>
                  setFormData({ ...formData, reference_id: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-block">
            <label>Expected Date</label>
            <div className="input-cont">
              <input
                type="datetime-local"
                className="text-input"
                value={formData.expected_date}
                onChange={(e) =>
                  setFormData({ ...formData, expected_date: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-block">
            <label>Arrival Date</label>
            <div className="input-cont">
              <input
                type="datetime-local"
                className="text-input"
                value={formData.received_date}
                onChange={(e) =>
                  setFormData({ ...formData, received_date: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-block">
            <label>Currency</label>
            <div className="input-cont">
              <select
                className="text-input"
                value={formData.currency}
                onChange={(e) =>
                  setFormData({ ...formData, currency: e.target.value })
                }
              >
                <option value="USD">USD</option>
                <option value="MXN">MXN</option>
              </select>
            </div>
          </div>
          <div className="form-block">
            <label>Notes</label>
            <div className="input-cont">
              <textarea
                className="text-input"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    notes: e.target.value,
                  }))
                }
              >
                {formData.notes}
              </textarea>
            </div>
          </div>
          <div className="full-cont">
            {isLoading ? (
              <Spinner />
            ) : (
              <>
                <Button
                  labelKey="submit"
                  type="submit"
                  variant="primary"
                />
                <Button
                  labelKey="cancel"
                  type="button"
                  variant="secondary"
                  onClick={close}
                />
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateReceipt;
